module.exports = __webpack_public_path__ + "img/12.74187785.png";